import React from 'react';
import { PremiumUser } from '../features/login/PremiumUser';

export const UserContext = React.createContext<PremiumUser | null>(null);